import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const FeatureShowcase = () => {
  const [currentFeature, setCurrentFeature] = useState(0);

  const features = [
    {
      icon: 'MessageSquare',
      title: 'AI-Powered Conversations',
      description: 'Find your perfect job through natural language search. Just tell us what you\'re looking for.',
      testimonial: {
        text: "Found my dream job in just 3 conversations. The AI understood exactly what I was looking for.",
        author: "Sarah Chen",
        role: "Senior Developer at TechCorp"
      }
    },
    {
      icon: 'Users',
      title: 'Smart Candidate Matching',
      description: 'Our AI analyzes your profile and matches you with opportunities that align with your skills and goals.',
      testimonial: {
        text: "The matching algorithm is incredible. Every job recommendation was relevant to my experience.",
        author: "Michael Rodriguez",
        role: "Product Manager at InnovateLab"
      }
    },
    {
      icon: 'TrendingUp',
      title: 'Career Growth Insights',
      description: 'Get personalized recommendations for skill development and career advancement opportunities.',
      testimonial: {
        text: "Recrutees helped me identify the skills I needed and connected me with the right opportunities.",
        author: "Emily Johnson",
        role: "Data Scientist at DataFlow"
      }
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % features?.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [features?.length]);

  const currentFeatureData = features?.[currentFeature];

  return (
    <div className="hidden lg:flex lg:flex-1 lg:flex-col lg:justify-center lg:px-8 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl mb-6">
            <Icon 
              name={currentFeatureData?.icon} 
              size={32} 
              className="text-primary"
            />
          </div>
          <h2 className="text-2xl font-bold text-foreground mb-4">
            {currentFeatureData?.title}
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed">
            {currentFeatureData?.description}
          </p>
        </div>

        <div className="bg-card rounded-xl p-6 shadow-card border border-border">
          <div className="flex items-start space-x-1 mb-4">
            {[...Array(5)]?.map((_, i) => (
              <Icon 
                key={i}
                name="Star" 
                size={16} 
                className="text-yellow-400 fill-current"
              />
            ))}
          </div>
          <blockquote className="text-foreground mb-4 italic">
            "{currentFeatureData?.testimonial?.text}"
          </blockquote>
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
              <span className="text-white font-semibold text-sm">
                {currentFeatureData?.testimonial?.author?.split(' ')?.map(n => n?.[0])?.join('')}
              </span>
            </div>
            <div>
              <div className="font-semibold text-foreground text-sm">
                {currentFeatureData?.testimonial?.author}
              </div>
              <div className="text-muted-foreground text-xs">
                {currentFeatureData?.testimonial?.role}
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center space-x-2 mt-6">
          {features?.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentFeature(index)}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === currentFeature ? 'bg-primary' : 'bg-border'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureShowcase;